<template>
    <div :class="{ 'd-flex flex-fill justify-content-end': deportes }">
        <button 
            v-if="!event.preventa?.registro_preventa_activo && !event.preventa?.venta_preventa_activa"
            class="button desactivar"
            :class="deportes ? 'large-button sitecolor-content d-flex align-items-center justify-content-center' : 'w-100 clases-teatros'"
        >
            {{ $t('preventa.registro_cerrado') }}
        </button>
        <router-link
            v-else-if="event.preventa?.registro_preventa_activo && !(event.preventa.venta_preventa_activa && event.preventa?.registrado_en_preventa)"
            :to="!desactivarPreventa ? { name: 'front.eventos.registro-preventa', params: { event_id: event.id, sesion_id: event.sesion_id }} : ''"
            class="button"
            :class="{
                'desactivar': registradoEnPreventa && deportes,
                'red-content': registradoEnPreventa && !deportes,
                'effect-button': deportes && !registradoEnPreventa,
                'large-button sitecolor-content d-flex align-items-center justify-content-center': deportes,
                'w-100 clases-teatros': !deportes
            }"
        >
            <span class="mr-1">{{ $t('partidos.registro_preventa') }}</span>
            <InfoToolTip v-if="registradoEnPreventa" :info="$t('preventa.registrado_preventa')" />
        </router-link>
        <router-link
            v-if="mostrarVenta && !desactivarVenta"
            :to="{ name: ruta, params: { event_id: event.id, sesion_id: event.sesion_id }}"
            class="button"
            :class="{
                'effect-button': deportes,
                'large-button sitecolor-content d-flex align-items-center justify-content-center': deportes,
                'w-100 clases-teatros': !deportes
            }"
        >
            <span class="mr-1">{{ $t('partidos.venta_preventa') }}</span>
            <InfoToolTip v-if="desactivarVenta && mensaje" :info="mensaje" />
        </router-link>
        <button
            v-else-if="mostrarVenta && desactivarVenta"
            class="button desactivar"
            :class="{
                'large-button sitecolor-content d-flex align-items-center justify-content-center': deportes,
                'w-100 clases-teatros': !deportes
            }"
        >
            <span class="mr-1">{{ $t('partidos.venta_preventa') }}</span>
            <InfoToolTip v-if="mensaje" :info="mensaje" />
        </button>
    </div>
</template>

<script setup>
    import { toRef } from 'vue';
    import InfoToolTip from '@/components/common/InfoToolTip';
    import { usePresaleButtons } from '@/composables/front/events/usePresaleButtons';

    const props = defineProps({
        event: {
            type: Object,
            required: true
        },
        deportes: {
            type: Boolean,
            default: true
        }
    });

    const eventRef = toRef(props, 'event');

    const {
        ruta,
        registradoEnPreventa,
        mostrarVenta,
        desactivarVenta,
        desactivarPreventa,
        mensaje,
        user
    } = usePresaleButtons(eventRef);
</script>

<style scoped>
    .desactivar {
        cursor: not-allowed;
        opacity: 0.5;
    }
    .red-content {
        background-color: #cc0000 !important;
        color: #ffffff !important;
        opacity: 0.65 !important;
        font-weight: bold !important;
    }
    .clases-teatros {
        border-radius: 60px;
    }
    @media (max-width: 1024px) {
        .clases-teatros {
            font-size: 12px !important;
            padding: 15px !important;
        }
    }
</style>